import { FileDTO } from "bnsights-control-library"

export class UploadJsonVM
{
      ResourcesFile:FileDTO
      SelectedResourceSet :string
}
     